<template>
  <div class="wheel-battle-team-row">
    <div v-if="showDrag" class="drag-handle">
      <img
        class="drag-handle-icon"
        src="https://images.snsports.cn/FoNm_W-fFIpo0jkc5jWWNEfpF7uX"
        alt=""
      />
    </div>
    <div v-if="showIndex" class="team-index">{{ displayIndex }}</div>
    <div class="team-logo-wrap">
      <img
        v-if="logoUrl"
        class="team-logo"
        :src="logoUrl"
        alt=""
      />
      <div v-else class="team-logo team-logo-placeholder" />
    </div>
    <div class="team-name">{{ team.name || '-' }}</div>
    <div class="team-action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
import { resolveTeamLogoUrl } from '../utils/team-logo'

export default {
  name: 'WheelBattleTeamRow',
  props: {
    team: {
      type: Object,
      default: function () {
        return {}
      }
    },
    matchLogo: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    showDrag: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayIndex: function () {
      return this.index + 1
    },
    logoUrl: function () {
      return resolveTeamLogoUrl(this.team, this.matchLogo, 30, 30)
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-team-row {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 16px;
  box-sizing: border-box;
  background: #fff;
}

.drag-handle {
  flex-shrink: 0;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.drag-handle-icon {
  width: 18px;
  height: 18px;
  display: block;
}

.team-index {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-right: 22px;
  background: #9FBED7;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.team-logo-wrap {
  flex-shrink: 0;
  margin-right: 10px;
}

.team-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}

.team-logo-placeholder {
  background: #e5e5e5;
}

.team-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #1d2129;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-action {
  flex-shrink: 0;
  margin-left: 8px;
}
</style>
